
import TypeformService from "@soenergy/frontend-library/src/services/TypeformService"
import BackLink from "@soenergy/frontend-library/src/components/BackLink.vue"
import pageMixin from "@/mixins/pageMixin"

export default {
  name: "MovingIn",
  components: {
    BackLink
  },
  mixins: [pageMixin],
  asyncData({ $storyblokHelper }) {
    return $storyblokHelper.get({
      id: "website/move-in",
      version: "2"
    })
  },
  mounted() {
    this.loadTypeformForPostcode()
  },
  methods: {
    loadTypeformForPostcode() {
      TypeformService.openWidget(this.content.typeformLink, {
        container: this.$refs.typeformWrapper,
        inlineOnMobile: true
      })
    }
  }
}
